module.exports = __webpack_public_path__ + "img/32.94353674.jpg";